/** Mirror of Config::IMG_W / IMG_H for lightbox metadata. */
export const Config = {
  IMG_W: 480,
  IMG_H: 360,
} as const;
